import { render, staticRenderFns } from "./DocumentSearchResults.vue?vue&type=template&id=05d85746&scoped=true"
import script from "./DocumentSearchResults.vue?vue&type=script&lang=js"
export * from "./DocumentSearchResults.vue?vue&type=script&lang=js"
import style0 from "./DocumentSearchResults.vue?vue&type=style&index=0&id=05d85746&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d85746",
  null
  
)

export default component.exports